import { ApolloLink } from '@apollo/client';
import { persistedQueryLink } from './persistedQueryLink';
import { readSessionLink } from './readSessionLink';
import { logoutLink } from './logoutLink';
import { cleanTypenameLink } from './cleanTypenameLink';
import { requiresAuthMiddleware } from './requiresAuthLink';
import { transportLink } from './transportLink';
import { precacheLink } from './precacheLink';
import { telemetryLink } from './telemetryLink';

export const link = ApolloLink.from([
  persistedQueryLink,
  readSessionLink,
  telemetryLink,
  logoutLink,
  cleanTypenameLink,
  precacheLink,
  requiresAuthMiddleware,
  transportLink,
]);
